export default "__VITE_ASSET__B1a9_P5o__"